import { merchantIdMatcher } from './regexes';
import { AppMode } from '../models/enums';

export const getAppMarketMode = (path: string = location.href): AppMode => getMerchantId(path) ? AppMode.Private : AppMode.Public;

export const getMerchantId = (path: string = location.href): string => {
  let match = path.match(merchantIdMatcher) || [null, sessionStorage.getItem('merchantId')];

  return match[1] || "";
}

export const isPublicApp = (): boolean => getAppMarketMode() === AppMode.Public;
export const isPrivateApp = (): boolean => getAppMarketMode() === AppMode.Private;

/* When the merchant tries to install an application from logged-out state, the user is redirected to login page with
   autoInstall and subscriptionId passed as parameters. Below function retrieves these parameteres from session once 
   logged-in and redirected to appdetails page
*/
export const getAppDetailsRedirectedInfo = (): { [key: string]: string; } =>{
  const getAutoInstall = sessionStorage.getItem('autoInstall');
  const getSubscriptionId = sessionStorage.getItem('subscriptionId');
  return {autoInstall : getAutoInstall || '', subscriptionId: getSubscriptionId || ''}
}
export const removeAppDetailsRedirectedInfo = ()=>{
  sessionStorage.removeItem("autoInstall")
  sessionStorage.removeItem("subscriptionId")

}